module.exports = __webpack_public_path__ + "assets/img/vote_num.fb00fc03.png";